(()=>{
  if('scrollRestoration' in history)history.scrollRestoration='manual';

  scrollTo({top:0,left:0,behavior:'instant'});

  const removePreviewFromTabOrder=root=>{
    if(root.matches?.('.feature-anki-frame'))root.tabIndex=-1;
    root.querySelectorAll?.('.feature-anki-frame').forEach(frame=>{frame.tabIndex=-1});
  };

  const start=()=>{
    removePreviewFromTabOrder(document);
    const observer=new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
      if(node.nodeType===Node.ELEMENT_NODE)removePreviewFromTabOrder(node);
    })));
    observer.observe(document.body,{childList:true,subtree:true});
  };

  if(document.readyState==='loading')addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
